<template>
    <div class="order-actions">
        <button class="btn btn--danger" @click="refundOpen = true">Вернуть средства</button>
        <button class="btn btn--primary" @click="markFulfilled">Отметить выполненным</button>
        <button class="btn btn--danger" @click="cancelOpen = true">Отменить заказ</button>

        <RefundOrderDialog
            v-if="refundOpen"
            :open="refundOpen"
            :order-id="orderId"
            @close="refundOpen = false"
            @done="onDone"
        />
        <dialog v-if="cancelOpen" :open="cancelOpen" class="action-dialog">
            <h3>Отменить заказ?</h3>
            <label>Причина
                <textarea v-model="cancelReason" rows="3" />
            </label>
            <div class="actions">
                <button class="btn btn--danger" :disabled="busy" @click="submitCancel">
                    {{ busy ? 'Отменяю…' : 'Отменить' }}
                </button>
                <button class="btn" @click="cancelOpen = false">Назад</button>
            </div>
        </dialog>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import RefundOrderDialog from './RefundOrderDialog.vue';

const props = defineProps<{ detail: { id: number | string } }>();
const refundOpen = ref(false);
const cancelOpen = ref(false);
const cancelReason = ref('');
const busy = ref(false);

const orderId = (): string => String(props.detail.id);

async function markFulfilled(): Promise<void> {
    if (!confirm('Отметить заказ как выполненный?')) return;
    await request({ method: 'post', url: `/admin-api/orders/${orderId()}/mark-fulfilled/`, data: {} });
    onDone();
}

async function submitCancel(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/orders/${orderId()}/cancel/`,
            data: { reason: cancelReason.value },
        });
        cancelOpen.value = false;
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    refundOpen.value = false;
    cancelOpen.value = false;
    window.location.reload();
}
</script>

<style scoped>
.order-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog textarea { width: 100%; box-sizing: border-box; font-size: 1rem; }
    .actions .btn { min-height: 2.5rem; }
    .order-actions .btn { min-height: 2.5rem; }
}
</style>
